import React, { useCallback, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";

import RoteListContext from "./Context";

const Provider = ({ children }) => {
  const listRef = useRef(null);
  const [scrollToRoute, setScrollToRoute] = useState(null);
  const scrollTo = useCallback(
    (selectedRoute) => setScrollToRoute(selectedRoute),
    []
  );
  const contextValue = useMemo(
    () => ({
      listRef,
      scrollTo,
      scrollToRoute,
    }),
    [listRef, scrollTo, scrollToRoute]
  );

  return (
    <RoteListContext.Provider value={contextValue}>
      {children}
    </RoteListContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node,
};

export default Provider;
